import "./ToolReviews.module.css";
import Header from "@/reusable_sections/Header";
import AllExpertReviews from "./sections/AllExpertReviews";
import SelectionFaq from "./sections/SelectionFaq";
import Footer from "@/reusable_sections/Footer";
export default function ToolReviewsPage() {
  return <div>
      <Header />
      <AllExpertReviews />
      <SelectionFaq />
      <Footer />
    </div>;
}